import CustomPriceList from './CustomPriceList';

export default CustomPriceList;